export default "__VITE_ASSET__DXySoEs3__"